import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex, Text, Tooltip, Box, getPaletteColor } from 'pcln-design-system'
import PropTypes from 'prop-types'
import { Overnight } from 'pcln-icons'

const StyledToolTip = styled(Tooltip)`
  white-space: nowrap;
`

export const SummaryText = styled(Text.span)`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 0 4px;
  border-radius: 10px;
  height: 16px;
  font-size: 12px;
  white-space: nowrap;
  background-color: ${getPaletteColor('alert.light')};
`

export const FlexRow = styled(Flex)`
  flex-direction: row;
  flex-wrap: wrap;

  @media only screen and (max-width: 32em) {
    width: 100%;
  }
`

const ToggleToolTip = (bool, toggleToolTip) => () => {
  toggleToolTip(bool)
}

const SliceTitle = ({
  isOvernight,
  duration,
  title,
  showAirportToolTip,
  arrivalDateText,
  isDepartureSummary,
  departureSummaryText = 'Your departure flight:',
}) => {
  const [showToolTip, toggleToolTip] = useState(false)
  const stopPropagation = (e) => e.stopPropagation()

  return (
    <>
      <FlexRow mb={isDepartureSummary ? 0 : [2, 3]} data-testid='slice-title-container'>
        {isDepartureSummary ? (
          <FlexRow>
            <Text bold data-testid='slice-details-title' fontSize='12px' pr={'2'}>
              {departureSummaryText}
            </Text>
          </FlexRow>
        ) : null}
        <Text bold data-testid='slice-details-title' fontSize='12px' color={'text.light'}>
          {title}
        </Text>
        {isOvernight && (
          <Box
            onMouseEnter={ToggleToolTip(true, toggleToolTip)}
            onMouseLeave={ToggleToolTip(false, toggleToolTip)}
            data-testid='overnight-hover'
            // onClick prevents tooltip click from selecting listing
            onClick={stopPropagation}
          >
            {showToolTip && showAirportToolTip && (
              <StyledToolTip bg='background.darkest' color='text.lightest' zIndex={1} top center>
                {'Overnight'}
              </StyledToolTip>
            )}
            <Overnight ml={2} mt='-4px' width='14px' color='text.light' />
          </Box>
        )}
        <Text fontSize={0} ml={2} color='text.light' data-testid='slice-duration'>
          {duration}
        </Text>
        {arrivalDateText ? <SummaryText>Arrives: {arrivalDateText}</SummaryText> : null}
      </FlexRow>
    </>
  )
}

SliceTitle.propTypes = {
  /** Boolean to display the overnight icon */
  isOvernight: PropTypes.bool,

  /** Duration string to display at top */
  duration: PropTypes.string,

  /** Title of component */
  title: PropTypes.string.isRequired,

  /** SETI for showing hover tooltip */
  showAirportToolTip: PropTypes.bool,

  arrivalDateText: PropTypes.string,

  /** Is Departure Summary */
  isDepartureSummary: PropTypes.bool,

  /** Is DepartureSummary Text  */
  departureSummaryText: PropTypes.any,
}

export default SliceTitle
